import type { RouteLocationRaw } from 'vue-router';
import { faFileChartColumn, faSitemap, type IconDefinition } from '@fortawesome/pro-light-svg-icons';

export interface ReportCard {
  name: string;
  title: string;
  description: string;
  icon: IconDefinition;
  to: RouteLocationRaw;
  requiredPrivilege: string;
}

export const allReports: ReportCard[] = [
  {
    name: 'gas-actions',
    title: 'Gas Actions Report',
    description: 'Gas actions recorded across work orders.',
    icon: faFileChartColumn,
    to: { name: 'work-order-gas-report' },
    requiredPrivilege: 'read-workorder',
  },
  {
    name: 'hierarchy-checks',
    title: 'Asset Hierarchy Checks',
    description: 'Data-quality checks over the asset and equipment hierarchy.',
    icon: faSitemap,
    to: { name: 'asset-hierarchy-checks' },
    requiredPrivilege: 'read-equipment',
  },
];

// Any-of union for the Reports nav item — adding a report here automatically extends the nav guard.
export const reportPrivileges = [...new Set(allReports.map((report) => report.requiredPrivilege))];
